export default "__VITE_ASSET__Co2x2f3U__"